export * from "./http";

export const NONE = "-";
